import { Button, Card, CardContent, CardHeader, Tab, Tabs, Typography, makeStyles } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ItemTabs from "./item-tabs/item-tabs";

const ItemsListDetailsContainer = () => {
    const { item_id } = useParams();
  
    return (
      <>
        <div style={{ padding: 20 }}>
          <ItemTabs item_id={item_id}/>
        </div>
      </>
    );
  };
  
  export default ItemsListDetailsContainer;